import { Box, Button, CloseButton, Dialog, Icon, IconButton, Portal, useBreakpointValue } from '@chakra-ui/react'
import React, { useState } from 'react'
import Landing from './Components/Landing'
import Navbar from '../../components/core/Navbar'
import { LuMoon, LuSun } from 'react-icons/lu'
import { useColorMode } from '../../components/ui/color-mode'
import WhyUs from './Components/WhyUs'
import OurService from './Components/OurService'
import OurCollaborations from './Components/OurCollaborations'
import OurNetwork from './Components/OurNetwork'
import OurStats from './Components/OurStats'
import OurLocation from './Components/OurLocation'
import { motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'
import OurOperatingSystem from './Components/OurOperatingSystem'
import Testimonials from './Components/Testimonials'
import Footer from './Components/Footer'
import OurOffice from './Components/OurOffice'
import FAQ from './Components/FAQ'
//import BlogShortcut from './Components/BlogShortcut'
import ScrollToTopButton from '../../components/core/ScrollToTopButton'
import BotsAssistant from '../../components/core/Bots'
import BlogShortcut from './Components/BlogShortcut'


export const SectionWrapper = ({ children, delay = 0, disable3D = false }) => {
  const container = useRef(null)



  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end start"]
  })

  const isMobile = useBreakpointValue({ base: true, md: false })
  const rotateX = useTransform(scrollYProgress, [0, 1], [0, 35])
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85])


  return (
    <Box
      ref={container}
      position={'relative'}
      zIndex={1}
      overflow={'hidden'}
      w={'full'}
      style={{ perspective: '1000px' }}
    >
      <motion.div
        style={{
          rotateX: isMobile || disable3D ? 0 : rotateX,
          scale: isMobile || disable3D ? 1 : scale,

          transformOrigin: "top center"
        }}
        initial={{ opacity: 0, y: 50, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, delay, ease: "easeOut" }}
        viewport={{ once: true, margin: "-100px" }}
      >
        {children}
      </motion.div>
    </Box>
  )
}

const Home = () => {

  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <Box>
      <Navbar />
      <SectionWrapper disable3D>
        <Landing />
      </SectionWrapper>

      <SectionWrapper disable3D>
        <OurService />
      </SectionWrapper>

      <SectionWrapper disable3D>
        <WhyUs />
      </SectionWrapper>


      <SectionWrapper>
        <OurCollaborations />
      </SectionWrapper>
      

      <SectionWrapper disable3D>
        <OurStats />
        <OurOperatingSystem/>
      </SectionWrapper>

      {/* <StartUp/> */}


      <SectionWrapper>
        <OurNetwork />
      </SectionWrapper>

      <OurLocation />

      <Testimonials/>

      <SectionWrapper>
        <OurOffice />
      </SectionWrapper>

      <FAQ/>
      {/* <BlogShortcut /> */}
      <Footer/>

      {/* floatting button */}
      <IconButton position={'fixed'} opacity={0.7} bottom={4} right={4} shadow={'xl'} zIndex={1000} onClick={toggleColorMode} variant={'solid'} rounded={'full'}>
        <Icon boxSize={4}>
          {colorMode === 'light' ? <LuMoon /> : <LuSun />}
        </Icon>
      </IconButton>
      {/* <ScrollToTopButton /> */}
      <BotsAssistant />



    </Box>
  )
}

export default Home